module.exports = __webpack_public_path__ + "static/img/bg-qdcg.cbb10bf7.jpg";